import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "app-wrapper" }
const _hoisted_2 = { class: "dialog-footer" }

import { computed, ref, Ref, reactive } from 'vue'
import { ElDialog } from 'element-plus'
import { useI18n } from 'vue-i18n'
import { getOperationPaymentChannel, upsertOperationPaymentChannel } from '@/api/operation'
import { ElInput } from 'element-plus'
import { ElMessage, ElMessageBox } from 'element-plus'
import useProtocolEnums from '@/hooks/useProtocolEnums'
import { PaymentChannel } from '@/types/types'
import YeeBindMiniapp from './YeeBindMiniapp.vue'
import useFormRules from '@/hooks/useFormRules'
import FormRulesFactory from '@/common/formRules'
import { isSuperadmin } from '@/store/tool'


import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'OperatorPaymnetChannel',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  operatorId: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props

const formRefs = reactive<Record<string, any>>({})
// 回调函数动态存储表单实例
const setFormRef = (channelType: string | number, el: any) => {
  formRefs[channelType] = el
}
const getFormRules = (channelType: any) => {
  return channelType === PaymentChannel.PC_PAYPAL && formData.value.config.paypal
    ? paypalFormRule
    : paypalFormRule // todo new channel
}
const paypalFormRule = ref({
  ...FormRulesFactory.generateCustomRules(
    [
      'config.paypal.account',
      'config.paypal.clientId',
      'config.paypal.clientSecret',
      'config.paypal.apiBase',
      'config.paypal.env',
      'config.alipay.appid',
      'config.alipay.mctPrivateKey',
      'config.alipay.aliPublicKey',
      'config.alipay.aliEncryptKey',
      'config.yeepay.appid',
      'config.yeepay.parentMerchantNo',
      'config.yeepay.merchantCode',
      'config.yeepay.payPrivateKey',
      'config.yeepay.payPublicKey',
      'config.wechatpay.appid',
      'config.wechatpay.mchId',
      'config.wechatpay.subMchId',
      'config.wechatpay.mchPrivateKey',
      'config.wechatpay.mchApiV3Key',
      'config.wechatpay.mchCerSerNum',
    ],
    'inputEmpty',
    'inputInvalid',
  ),
})
const { t } = useI18n()
const { getPaymentChannelDesc } = useProtocolEnums()

const { createLetterStartRule } = useFormRules()
const rules = {
  name: [...createLetterStartRule()],
}

const isadmin = computed(() => {
  return isSuperadmin()
})


const bindMiniappDialog = ref(false)
const bindMiniappPCId = ref('0')

const addConfigDialog = ref(false)
const addConfigChannel = ref(PaymentChannel.PC_UNKNOWN)

const editableTabsValue = ref(PaymentChannel.PC_UNKNOWN)
const configDatas = ref<any[]>([])
const formData: Ref<Record<string, any>> = ref({
  config: {},
})
const configLoading = ref(false)



const handleTabClick = (name: any) => {
  const foundItem = configDatas.value.find((item) => item.channelType == name)
  if (foundItem) {
    formData.value.config = foundItem
    editableTabsValue.value = foundItem.channelType
  }
}

const handleAddTab = () => {
  addConfigChannel.value = PaymentChannel.PC_UNKNOWN
  addConfigDialog.value = true
}
const checkExists = (nc: PaymentChannel) => {
  return !!configDatas.value.find((item) => item.channelType === nc)
}

const bindMiniapp = (pc: any) => {
  bindMiniappDialog.value = true
  bindMiniappPCId.value = pc.id
}

const handleaddConfigChannel = () => {
  addConfigDialog.value = false

  if (addConfigChannel.value == PaymentChannel.PC_UNKNOWN) {
    return
  }
  let name = getPaymentChannelDesc(addConfigChannel.value)
    ? getPaymentChannelDesc(addConfigChannel.value)
    : props.operatorId
  let config = {
    bindOperatorId: props.operatorId,
    channelType: addConfigChannel.value,
    name: name,
    desc: name,
    base: {
      supportProfitSharing: false,
      enableProfitSharing: false,
      supportAnotherPay: false,
      enableAnotherPay: false,
    },
    yeepay: {},
    alipay: {},
    paypal: {
      account: '',
      clientId: '',
      clientSecret: '',
      apiBase: '',
      env: '',
    },
    wechatpay: {
      appid: '',
      mchId: '',
      subMchId: '',
      mchPrivateKey: '',
      mchApiV3Key: '',
      mchCerSerNum: '',
    }
  }
  configDatas.value.push(config)
  editableTabsValue.value = addConfigChannel.value
  formData.value.config = config
}

const isSubmitting = ref(false)
const submit = async () => {
  try {
    await formRefs[formData.value.config.channelType].validate()
    isSubmitting.value = true
    if (formData.value.config.channelType == PaymentChannel.PC_YEEPAY) {
      formData.value.config.base = {
        supportProfitSharing: true,
        enableProfitSharing: true,
        supportAnotherPay: true,
        enableAnotherPay: true,
      }
    }
    await upsertOperationPaymentChannel(formData.value)
    ElMessage.success(t(`Base.updateSuccess`))
  } catch (error) {
    console.log('--->submit error: ', error)
  } finally {
    isSubmitting.value = false
  }
}

const loadData = async () => {
  try {
    configLoading.value = true
    const data = await getOperationPaymentChannel({ operatorID: props.operatorId })
    if (Array.isArray(data.configs)) {
      configDatas.value = data.configs // 确保返回的是数组
      if (configDatas.value.length > 0) {
        editableTabsValue.value = configDatas.value[0].channelType
        formData.value.config = configDatas.value[0]
      }
    } else {
      editableTabsValue.value = PaymentChannel.PC_UNKNOWN
      configDatas.value = [] // 如果返回的不是数组，初始化为空数组
      console.error('Invalid data format, expected an array.')
    }
    // rawData = cloneDeep(configs.value)
    console.log('--->rawData: ', configDatas.value)
  } catch (error) {
    console.log('--->load error: ', error)
  } finally {
    configLoading.value = false
  }
}
loadData()

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, { class: "app-card allow-overflow custom-card" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tabs, {
          modelValue: editableTabsValue.value,
          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((editableTabsValue).value = $event)),
          type: "card",
          addable: "",
          class: "demo-tabs",
          onEdit: handleAddTab,
          onTabChange: handleTabClick
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(configDatas.value, (item) => {
              return (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: item.channelType,
                label: _unref(getPaymentChannelDesc)(item.channelType),
                name: item.channelType
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form, {
                    ref_for: true,
                    ref: (el) => setFormRef(item.channelType, el),
                    rules: getFormRules(item.channelType),
                    model: formData.value,
                    "label-position": "right",
                    size: "default",
                    "label-width": "300px",
                    style: {"max-width":"800px"}
                  }, {
                    default: _withCtx(() => [
                      (item.channelType == _unref(PaymentChannel).PC_ALI_PAY && formData.value.config.alipay)
                        ? (_openBlock(), _createBlock(_component_el_row, {
                            key: 0,
                            gutter: 20
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    prop: "config.alipay.appid",
                                    required: ""
                                  }, {
                                    label: _withCtx(() => [
                                      _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.appid')), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_unref(ElInput), {
                                        modelValue: formData.value.config.alipay.appid,
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.config.alipay.appid) = $event))
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    prop: "config.alipay.mctPrivateKey",
                                    required: ""
                                  }, {
                                    label: _withCtx(() => [
                                      _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.mctPrivateKey')), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_unref(ElInput), {
                                        type: "textarea",
                                        rows: 3,
                                        modelValue: formData.value.config.alipay.mctPrivateKey,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.config.alipay.mctPrivateKey) = $event))
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    prop: "config.alipay.aliPublicKey",
                                    required: ""
                                  }, {
                                    label: _withCtx(() => [
                                      _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.aliPublicKey')), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_unref(ElInput), {
                                        type: "textarea",
                                        rows: 3,
                                        modelValue: formData.value.config.alipay.aliPublicKey,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.config.alipay.aliPublicKey) = $event))
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    prop: "config.alipay.aliEncryptKey",
                                    required: ""
                                  }, {
                                    label: _withCtx(() => [
                                      _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.aliEncryptKey')), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_unref(ElInput), {
                                        modelValue: formData.value.config.alipay.aliEncryptKey,
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.config.alipay.aliEncryptKey) = $event))
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (item.channelType == _unref(PaymentChannel).PC_YEEPAY && formData.value.config.yeepay)
                        ? (_openBlock(), _createBlock(_component_el_row, {
                            key: 1,
                            gutter: 20
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, { span: 18 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    prop: "config.yeepay.appid",
                                    required: ""
                                  }, {
                                    label: _withCtx(() => [
                                      _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.appid')), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_unref(ElInput), {
                                        modelValue: formData.value.config.yeepay.appid,
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.config.yeepay.appid) = $event))
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, { span: 6 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_button, {
                                    onClick: ($event: any) => (bindMiniapp(item))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('Operation.bindMiniapp')), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    prop: "config.yeepay.parentMerchantNo",
                                    required: ""
                                  }, {
                                    label: _withCtx(() => [
                                      _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.parentMerchantNo')), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_unref(ElInput), {
                                        modelValue: formData.value.config.yeepay.parentMerchantNo,
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.config.yeepay.parentMerchantNo) = $event))
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    prop: "config.yeepay.merchantCode",
                                    required: ""
                                  }, {
                                    label: _withCtx(() => [
                                      _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.merchantCode')), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_unref(ElInput), {
                                        modelValue: formData.value.config.yeepay.merchantCode,
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.config.yeepay.merchantCode) = $event))
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    prop: "config.yeepay.payPrivateKey",
                                    required: ""
                                  }, {
                                    label: _withCtx(() => [
                                      _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.payPrivateKey')), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_unref(ElInput), {
                                        type: "textarea",
                                        rows: 3,
                                        modelValue: formData.value.config.yeepay.payPrivateKey,
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.config.yeepay.payPrivateKey) = $event))
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    prop: "config.yeepay.payPublicKey",
                                    required: ""
                                  }, {
                                    label: _withCtx(() => [
                                      _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.payPublicKey')), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_unref(ElInput), {
                                        type: "textarea",
                                        rows: 3,
                                        modelValue: formData.value.config.yeepay.payPublicKey,
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.config.yeepay.payPublicKey) = $event))
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true),
                      (item.channelType == _unref(PaymentChannel).PC_YEEPAY && formData.value.config.yeepay && _unref(isadmin) )
                        ? (_openBlock(), _createBlock(_component_el_row, {
                            key: 2,
                            gutter: 20
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    prop: "config.tradeFeePercentage",
                                    required: ""
                                  }, {
                                    label: _withCtx(() => [
                                      _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.tradeFeePercentageConf')), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_unref(ElInput), {
                                        modelValue: formData.value.config.tradeFeePercentage,
                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.value.config.tradeFeePercentage) = $event))
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    prop: "config.tradeFeePercentageCDef",
                                    required: ""
                                  }, {
                                    label: _withCtx(() => [
                                      _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.tradeFeePercentageCDef')), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_unref(ElInput), {
                                        modelValue: formData.value.config.tradeFeePercentageCDef,
                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.value.config.tradeFeePercentageCDef) = $event))
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    prop: "config.withdrawFee",
                                    required: ""
                                  }, {
                                    label: _withCtx(() => [
                                      _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.withdrawFee')), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_unref(ElInput), {
                                        modelValue: formData.value.config.withdrawFee,
                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.value.config.withdrawFee) = $event))
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    prop: "config.withdrawFeeCDef",
                                    required: ""
                                  }, {
                                    label: _withCtx(() => [
                                      _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.withdrawFeeCDef')), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_unref(ElInput), {
                                        modelValue: formData.value.config.withdrawFeeCDef,
                                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formData.value.config.withdrawFeeCDef) = $event))
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (item.channelType == _unref(PaymentChannel).PC_WECHAT_PAY && formData.value.config.wechatpay)
                        ? (_openBlock(), _createBlock(_component_el_row, {
                            key: 3,
                            gutter: 20
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    prop: "config.wechatpay.appid",
                                    required: ""
                                  }, {
                                    label: _withCtx(() => [
                                      _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.appid')), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_unref(ElInput), {
                                        modelValue: formData.value.config.wechatpay.appid,
                                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formData.value.config.wechatpay.appid) = $event))
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    prop: "config.wechatpay.mchId",
                                    required: ""
                                  }, {
                                    label: _withCtx(() => [
                                      _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.mchId')), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_unref(ElInput), {
                                        modelValue: formData.value.config.wechatpay.mchId,
                                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((formData.value.config.wechatpay.mchId) = $event))
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    prop: "config.wechatpay.subMchId",
                                    required: ""
                                  }, {
                                    label: _withCtx(() => [
                                      _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.subMchId')), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_unref(ElInput), {
                                        modelValue: formData.value.config.wechatpay.subMchId,
                                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((formData.value.config.wechatpay.subMchId) = $event))
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    prop: "config.wechatpay.mchPrivateKey",
                                    required: ""
                                  }, {
                                    label: _withCtx(() => [
                                      _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.mchPrivateKey')), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_unref(ElInput), {
                                        type: "textarea",
                                        rows: 3,
                                        modelValue: formData.value.config.wechatpay.mchPrivateKey,
                                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((formData.value.config.wechatpay.mchPrivateKey) = $event))
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    prop: "config.wechatpay.mchApiV3Key",
                                    required: ""
                                  }, {
                                    label: _withCtx(() => [
                                      _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.mchApiV3Key')), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_unref(ElInput), {
                                        modelValue: formData.value.config.wechatpay.mchApiV3Key,
                                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((formData.value.config.wechatpay.mchApiV3Key) = $event))
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    prop: "config.wechatpay.mchCerSerNum",
                                    required: ""
                                  }, {
                                    label: _withCtx(() => [
                                      _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.mchCerSerNum')), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_unref(ElInput), {
                                        modelValue: formData.value.config.wechatpay.mchCerSerNum,
                                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((formData.value.config.wechatpay.mchCerSerNum) = $event))
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (item.channelType == _unref(PaymentChannel).PC_PAYPAL && formData.value.config.paypal)
                        ? (_openBlock(), _createBlock(_component_el_row, {
                            key: 4,
                            gutter: 20
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    prop: "config.paypal.account",
                                    required: ""
                                  }, {
                                    label: _withCtx(() => [
                                      _createElementVNode("label", null, _toDisplayString(_unref(t)('Base.account')), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_unref(ElInput), {
                                        modelValue: formData.value.config.paypal.account,
                                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((formData.value.config.paypal.account) = $event))
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    prop: "config.paypal.clientId",
                                    required: ""
                                  }, {
                                    label: _withCtx(() => [
                                      _createElementVNode("label", null, _toDisplayString(_unref(t)('Base.clientid')), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_unref(ElInput), {
                                        type: "textarea",
                                        rows: 2,
                                        modelValue: formData.value.config.paypal.clientId,
                                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((formData.value.config.paypal.clientId) = $event))
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    prop: "config.paypal.clientSecret",
                                    required: ""
                                  }, {
                                    label: _withCtx(() => [
                                      _createElementVNode("label", null, _toDisplayString(_unref(t)('Base.clientSecret')), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_unref(ElInput), {
                                        type: "textarea",
                                        rows: 3,
                                        modelValue: formData.value.config.paypal.clientSecret,
                                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((formData.value.config.paypal.clientSecret) = $event))
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    prop: "config.paypal.apiBase",
                                    required: ""
                                  }, {
                                    label: _withCtx(() => [
                                      _createElementVNode("label", null, _toDisplayString(_unref(t)('Base.apiBase')), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_unref(ElInput), {
                                        modelValue: formData.value.config.paypal.apiBase,
                                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((formData.value.config.paypal.apiBase) = $event))
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    prop: "config.paypal.env",
                                    required: ""
                                  }, {
                                    label: _withCtx(() => [
                                      _createElementVNode("label", null, _toDisplayString(_unref(t)('Base.env')), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_unref(ElInput), {
                                        modelValue: formData.value.config.paypal.env,
                                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((formData.value.config.paypal.env) = $event))
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_col, {
                        span: 24,
                        class: "btn-col"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            disabled: !_ctx.$hasPermission('post'),
                            loading: isSubmitting.value,
                            onClick: submit
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('Base.saveChanges')), 1)
                            ]),
                            _: 1
                          }, 8, ["disabled", "loading"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["rules", "model"])
                ]),
                _: 2
              }, 1032, ["label", "name"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_unref(ElDialog), {
      modelValue: addConfigDialog.value,
      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((addConfigDialog).value = $event)),
      title: _unref(t)('Operation.selectPayment'),
      width: "30%",
      top: "25vh",
      "destroy-on-close": "",
      center: ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: handleaddConfigChannel
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('Base.confirm')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_el_radio_group, {
            modelValue: addConfigChannel.value,
            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((addConfigChannel).value = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_radio, {
                value: _unref(PaymentChannel).PC_PAYPAL,
                label: _unref(PaymentChannel).PC_PAYPAL,
                disabled: checkExists(_unref(PaymentChannel).PC_PAYPAL)
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('Operation.paypal')), 1)
                ]),
                _: 1
              }, 8, ["value", "label", "disabled"]),
              _createVNode(_component_el_radio, {
                value: _unref(PaymentChannel).PC_ALI_PAY,
                label: _unref(PaymentChannel).PC_ALI_PAY,
                disabled: checkExists(_unref(PaymentChannel).PC_ALI_PAY)
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('Operation.alipay')), 1)
                ]),
                _: 1
              }, 8, ["value", "label", "disabled"]),
              _createVNode(_component_el_radio, {
                value: _unref(PaymentChannel).PC_YEEPAY,
                label: _unref(PaymentChannel).PC_YEEPAY,
                disabled: checkExists(_unref(PaymentChannel).PC_YEEPAY)
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('Operation.yeepay')), 1)
                ]),
                _: 1
              }, 8, ["value", "label", "disabled"]),
              _createVNode(_component_el_radio, {
                value: _unref(PaymentChannel).PC_WECHAT_PAY,
                label: _unref(PaymentChannel).PC_WECHAT_PAY,
                disabled: checkExists(_unref(PaymentChannel).PC_WECHAT_PAY)
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('Operation.wechat')), 1)
                ]),
                _: 1
              }, 8, ["value", "label", "disabled"])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(YeeBindMiniapp, {
      modelValue: bindMiniappDialog.value,
      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((bindMiniappDialog).value = $event)),
      pcId: bindMiniappPCId.value
    }, null, 8, ["modelValue", "pcId"])
  ]))
}
}

})